/* eslint-disable import/prefer-default-export */
import tw, { theme } from 'twin.macro';

export const styles = {
  defaultInput: ({ $invalid, leftElement, rightElement }) => [
    tw`bg-white border border-silver-darken-20 rounded leading-32 px-16 w-full max-w-full text-lg text-black text-opacity-85 font-normal appearance-none`,
    `
          padding-top: .3125rem;
          padding-bottom: .3125rem;
          caret-color: ${theme`colors.blue.base`};
      `,
    tw`focus:(border-blue-base ring ring-blue-lighten-20)`,
    tw`disabled:(border-transparent bg-silver-lighten-15 cursor-not-allowed)`,
    tw`invalid:(border-red-darken-10)`,
    tw`invalid:focus:(border-red-darken-10 ring ring-red-lighten-20)`,
    $invalid &&
      tw`border-red-darken-10 focus:(border-red-darken-10 ring ring-red-lighten-20)`,
    leftElement && tw`pl-40`,
    rightElement && tw`pr-40`
  ],
  leftElement: tw`absolute top-0 left-0 m-8 py-2 flex`,
  rightContentWrapper: tw`absolute top-0 right-0 m-8 flex items-center`,
  rightElement: ({ rightElementButtonChild }) => [
    tw` py-2 flex`,
    rightElementButtonChild && tw`py-0`
  ]
};
